export default ({ course, permission }) => {
  if (course && (course.isOwnerOrSuperadmin ||
      (course.isAdmin && course.adminPermissions.includes(permission)))) {
    return true;
  }
  return false;
};
